import { useState } from "react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarSync, Apple, Copy } from "lucide-react";

export function CalendarioLink({ token, settore, label, colore, onColore }) {
  const [c, setC] = useState(colore);
  const q = settore ? `?settore=${settore}` : "";
  const url = `${API}/calendario/feed/${token}.ics${q}`;
  const webcal = url.replace(/^https?:\/\//, "webcal://");
  const google = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`;
  const id = settore || "personale";
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copiato"); }
    catch { toast.error("Copia non riuscita"); }
  };
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-4" data-testid={`cal-link-${id}`}>
      {label && (
        <div className="flex items-center gap-2 mb-3">
          <span className="h-3 w-3 rounded-full" style={{ background: c }} />
          <span className="font-semibold text-sm text-slate-900 dark:text-white">{label}</span>
          {onColore && (
            <label className="ml-auto flex items-center gap-2 text-xs text-slate-500 cursor-pointer">
              Colore
              <input type="color" value={c} data-testid={`cal-colore-${id}`} onChange={(e) => setC(e.target.value)}
                onBlur={() => c !== colore && onColore(c)} className="h-7 w-10 rounded border border-slate-200 dark:border-slate-700 bg-transparent cursor-pointer" />
            </label>
          )}
        </div>
      )}
      <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-2">
        <Button asChild size="sm" data-testid={`cal-apple-btn-${id}`}><a href={webcal}><Apple className="h-4 w-4 mr-1.5" />Collega a iPhone / Mac</a></Button>
        <Button asChild size="sm" variant="outline" data-testid={`cal-google-btn-${id}`}><a href={google} target="_blank" rel="noreferrer"><CalendarSync className="h-4 w-4 mr-1.5" />Aggiungi a Google</a></Button>
        <Button size="sm" variant="outline" onClick={copy} data-testid={`cal-copy-btn-${id}`}><Copy className="h-4 w-4 mr-1.5" />Copia link</Button>
      </div>
    </div>
  );
}
